export default __webpack_public_path__ + "static/media/livechat.35b2f9f4.mp3";